var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.categories),function(category,index){return _c('li',{key:index,class:{'-selected': category.selected},on:{"click":function($event){return _vm.toggleSelect(index)}}},[_c('svg',[_c('use',{attrs:{"xlink:href":`#icon-${category.icon}`}})]),_vm._v("\n    "+_vm._s(category.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }